module.exports = __webpack_public_path__ + "img/theo-roar.e4885986.svg";